import { TransStudies } from "lib/i18n/translations/studies";
import { JSXElementConstructor } from "react";
import { useConsentsMap } from "../../DataAndPrivacySection/hooks/useConsentsMap";

interface Study {
  title: JSXElementConstructor<any>;
  documentUrl: string;
  invitation: JSXElementConstructor<any>;
  purpose: JSXElementConstructor<any>;
  studyLink: () => string;
}

export function useStudyInfo(documentUrl: string): Study {
  const { studies } = useConsentsMap();
  const record: Record<string, Study> = {
    [studies.CARDIO]: {
      documentUrl: studies.CARDIO,
      title: TransStudies.Cardio.Title,
      invitation: TransStudies.Cardio.Invitation,
      purpose: TransStudies.Cardio.Purpose,
      studyLink: TransStudies.Cardio.Link,
    },
    [studies.DERMAFLOW]: {
      documentUrl: studies.DERMAFLOW,
      title: TransStudies.DermaFlow.Title,
      invitation: TransStudies.DermaFlow.Invitation,
      purpose: TransStudies.DermaFlow.Purpose,
      studyLink: TransStudies.DermaFlow.Link,
    },
    [studies.SPECTRUM]: {
      documentUrl: studies.SPECTRUM,
      title: TransStudies.Spectrum.Title,
      invitation: TransStudies.Spectrum.Invitation,
      purpose: TransStudies.Spectrum.Purpose,
      studyLink: TransStudies.Spectrum.Link,
    },
  };

  return record[documentUrl];
}
